import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { APP_CONFIG } from 'appConfig';

import DialogContent from '@material-ui/core/DialogContent';
import Dialog from '@material-ui/core/Dialog';

import DialogHeader from 'components/DialogHeader/DialogHeader';

export interface CommissionData {
  client: string;
  commissionId: string;
  contractNumber: string;
  token: string;
}

interface OwnProps {
  handleClose: (open: boolean) => void;
  commissionId: string;
  commissionsToken: string;
  contractId: string;
  clientName: string;
}

type Props = OwnProps;

const CommissionsModal: React.FC<Props> = ({ handleClose, commissionId, contractId, clientName, commissionsToken }) => {
  const { t } = useTranslation();
  const iframeRef = React.createRef<HTMLIFrameElement>();

  useEffect(() => {
    const handleEvents = (event: MessageEvent) => {
      if (event.origin !== APP_CONFIG.commissionsDomain) return;
      if (event.data && event.data.call === 'initCommissionSplitFrame') {
        const frameData = {
          access_token: commissionsToken,
          contract_id: contractId,
          client_name: clientName,
        };
        iframeRef?.current?.contentWindow &&
          iframeRef.current.contentWindow.postMessage(
            { call: 'sendToCommissionSplitFrame', value: frameData },
            APP_CONFIG.commissionsDomain,
          );
      }
      if (event.data && event.data.call === 'closeCommissionSplitFrame') {
        handleClose(false);
      }
    };

    window.addEventListener('message', handleEvents);

    return function cleanup() {
      window.removeEventListener('message', handleEvents);
    };
  }, [iframeRef, commissionsToken, clientName, contractId, handleClose]);

  const BTIframe = React.forwardRef((props, ref) => (
    <iframe
      ref={iframeRef}
      id="commissions"
      title="commissions"
      width="100%"
      height="600"
      style={{ border: 'none' }}
      src={`${APP_CONFIG.commissionsDomain}${APP_CONFIG.commissionsPath}/${commissionId}`}
    />
  ));

  return (
    <Dialog maxWidth="lg" open={true}>
      <DialogHeader onClose={() => handleClose(false)}>{t('commissions_modalTitle')}</DialogHeader>
      <DialogContent>
        <BTIframe ref={iframeRef} />
      </DialogContent>
    </Dialog>
  );
};

export default CommissionsModal;
